module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    staticClass: "bgm-setting",
    attrs: {
      "label": _vm.$t('actions.project.settings.bgmLabel')
    }
  }, [(!_vm.name) ? _c('div', [_c('el-button', {
    attrs: {
      "plain": true,
      "type": "primary"
    },
    on: {
      "click": _vm.editBgm
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.bgm.submit')))]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('hint.project.edit.bgm')))])], 1) : _c('div', {
    staticClass: "bgm-player"
  }, [_c('el-popover', {
    ref: "volume-popover",
    attrs: {
      "placement": "right",
      "trigger": "click",
      "width": "40",
      "popper-class": "vertical"
    }
  }, [_c('el-slider', {
    attrs: {
      "vertical": "",
      "height": "100px"
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  })], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.paused),
      expression: "!paused"
    }],
    staticClass: "player-btn",
    on: {
      "click": function($event) {
        _vm.player.pause();
        _vm.paused = true
      }
    }
  }, [_c('i', {
    staticClass: "ppj-icon-pause"
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paused),
      expression: "paused"
    }],
    staticClass: "player-btn",
    on: {
      "click": function($event) {
        _vm.player.play();
        _vm.paused = false
      }
    }
  }, [_c('i', {
    staticClass: "ppj-icon-play"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticClass: "btn-group"
  }, [_c('a', {
    directives: [{
      name: "popover",
      rawName: "v-popover:volume-popover",
      arg: "volume-popover"
    }],
    staticClass: "volume-btn btn"
  }, [_vm._v("音量")]), _vm._v(" "), _c('a', {
    staticClass: "remove-btn btn",
    on: {
      "click": function($event) {
        _vm.setData()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.delete')))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-412a7bca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/show/setting/form/bgm.card.vue
// module id = 915
// module chunks = 3